
import { computed, defineComponent, PropType, reactive } from 'vue'
// import { CompaniesDocument } from '@/types/firebaseCollectionContracts/CompaniesDocument'
// import { useStore } from 'vuex'
import { IAppDocument } from '@/types/interfaces/IAppDocument'
import { formatAddressObject } from '@/services/helpers'
// import { ICompanyBranch } from '@/types/interfaces/ICompanyBranch'
import { ICompanyBankAccount } from '@/types/interfaces/ICompanyBankAccount'

const columns = [
  {
    title: 'A/C Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'A/C No.',
    dataIndex: 'acno',
    key: 'acno',
  },
  {
    title: 'IFSC',
    dataIndex: 'ifsc',
    key: 'ifsc',
  },
  {
    title: 'Bank Name',
    dataIndex: 'bankName',
    key: 'bankName',
    // slots: { customRender: 'totalBranches' },
  },
  {
    title: 'Branch Name',
    dataIndex: 'branchName',
    key: 'branchName',
  },
  {
    title: 'Payee',
    dataIndex: 'payee',
    key: 'payee',
  },
]

export default defineComponent({
  name: 'BankAccountsTable',
  props: {
    bankAccountsList: {
      type: Object as PropType<IAppDocument<ICompanyBankAccount>[] | null>,
      required: true,
    },
  },
  setup(props) {
    // const store = useStore()
    const dataSource = computed(() => props.bankAccountsList)
    const totalTableRecords = computed(() => dataSource.value?.length)
    const showTotal = (total: number, range: Array<any>) => {
      return `${range[0]}-${range[1]} of ${total} items`
    }
    const pagination = reactive({
      position: 'bottom',
      showSizeChanger: true,
      showQuickJumper: false,
      total: totalTableRecords.value || 0,
      simple: false,
      pageSize: 10,
      showTotal: showTotal,
    })

    return {
      columns,
      pagination,
      dataSource,
      formatAddressObject,
    }
  },
})
